<template>
  <v-dialog
    v-model="opened"
    content-class="fines-dialog"
    max-width="450"
    persistent
  >
    <h3>{{ $t('fines.add') }}</h3>

    <v-btn class="close-btn" icon @click="opened = false">
      <v-icon size="27" color="#464646"> mdi-close-circle-outline </v-icon>
    </v-btn>

    <v-form
      ref="finesForm"
      class="fines-dialog__form"
      @submit.prevent="onSubmit"
    >
      <auto-select
        filled
        outlined
        full-data
        :label="$t('auto.fields.number')"
        :rules="[isRequired]"
        @change="
          (event) => {
            formData.car_id = event.id;
            carNumber = event.number;
          }
        "
      />

      <violation-date-menu-picker
        :date-time="formData.violation_date"
        @change="formData.violation_date = $event"
      />

      <v-text-field
        outlined
        filled
        dense
        disabled
        :label="$t('autoRents.tableHeaders.name')"
        :loading="driverLoading"
        :value="driverName"
      />

      <driver-select
        ref="driver-select"
        outlined
        filled
        :label="$t('common.fields.phone')"
        :rules="[isRequired]"
        :phone="driverPhone"
        :clearable="false"
        @change="
          (event) => {
            formData.driver_id = event.driver_id;
            driverPhone = event.phone;
            driverName = event.name;
          }
        "
      />

      <v-select
        v-model="formData.status"
        item-text="name"
        item-value="id"
        height="40"
        filled
        outlined
        dense
        :rules="[isRequired]"
        :label="$t('common.fields.status')"
        :items="statuses"
        :item-disabled="({ id }) => id === 3"
      />

      <v-text-field
        v-model="formData.amount"
        outlined
        filled
        dense
        :label="$t('common.fields.sum')"
        :rules="[onlyNumbers]"
      />

      <v-text-field
        v-model="formData.description"
        outlined
        filled
        dense
        :label="$t('common.table.description')"
      />

      <v-text-field
        v-model="formData.violation_number"
        outlined
        filled
        dense
        :label="$t('fines.table.prescriptionNumber')"
        :rules="[isRequired]"
      />

      <v-btn
        type="submit"
        color="warning"
        height="40"
        elevation="0"
        :loading="loading"
        block
      >
        {{ $t('common.btns.save') }}
      </v-btn>
    </v-form>
  </v-dialog>
</template>

<script>
import DriverSelect from '@/components/shared/DriverSelect.vue';
import AutoSelect from '@/components/shared/AutoSelect.vue';
import ViolationDateMenuPicker from './ViolationDateMenuPicker.vue';

export default {
  components: { DriverSelect, AutoSelect, ViolationDateMenuPicker },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: Boolean,
  },
  data: () => ({
    dateMenu: false,
    loading: false,
    driverLoading: false,
    carNumber: '',
    driverName: '',
    driverPhone: '',
    formData: {
      car_id: '',
      violation_date: '',
      driver_id: '',
      status: '',
      amount: '',
      description: '',
      violation_number: '',
    },
  }),
  watch: {
    opened(val) {
      if (!val) {
        this.$refs.finesForm.reset();
        this.carNumber = '';
        this.driverName = '';
        this.driverPhone = '';

        this.formData = {
          car_id: '',
          violation_date: '',
          driver_id: '',
          status: '',
          amount: '',
          description: '',
          violation_number: '',
        };
      }
    },
    driverRequestData({ date, number }) {
      if (date && number) {
        this.fetchDriverByDate({ date, number });
      }
    },
    'formData.car_id': {
      handler() {
        this.driverName = '';
        this.driverPhone = '';
        this.formData.driver_id = '';
      },
    },
  },
  computed: {
    opened: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('change', val);
      },
    },
    statuses() {
      return this.$store.state.fines.statuses;
    },
    driverRequestData() {
      return {
        date: this.formData.violation_date,
        number: this.carNumber,
      };
    },
  },
  methods: {
    isRequired(v) {
      const isValid = Boolean(v) || v === 0;
      return isValid || this.$t('common.fields.validation.field.required');
    },
    onlyNumbers(v) {
      if (!v) return true;
      return (
        /^[0-9]{1,12}$/.test(v) || this.$t('common.fields.validation.numbers')
      );
    },
    async onSubmit() {
      const isValid = this.$refs.finesForm.validate();

      if (!isValid) return;

      this.loading = true;
      const result = await this.$store.dispatch('fines/addNew', this.formData);

      this.loading = false;
      this.$emit('saved', result);
    },
    async fetchDriverByDate(params) {
      this.driverLoading = true;
      const { driver } = await this.$store.dispatch(
        'fines/fetchDriverByDate',
        params,
      );

      if (driver) {
        this.driverName = driver.user.name;
        this.driverPhone = driver.user.phone;
        this.formData.driver_id = driver.id;
      } else {
        this.driverName = '';
        this.driverPhone = '';
        this.formData.driver_id = '';
      }

      this.driverLoading = false;
    },
  },
};
</script>

<style lang="scss">
.fines-dialog {
  padding: 10px;
  background-color: #fff;

  h3 {
    text-align: center;
    color: #464646;
  }

  &__form {
    margin-top: 15px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    > * {
      max-width: 48%;
      width: 100%;
    }
  }

  .driver-select {
    width: 100%;
  }
}
</style>
